<template>
    <div class="infolistitem">
        <div class="level is-mobile">
            <div class="level-left">
                <div class="level-item is-hidden-mobile">
                    <span class="icon is-large">
                        <slot name="icon"></slot>
                    </span>
                </div>

                <div class="level-item">
                    <span class="infolistitem-title">
                        <slot name="title"></slot>
                    </span>

                    <span class="infolistitem-subtitle">
                        <slot name="subtitle"></slot>
                    </span>
                </div>
            </div>

            <div class="level-right">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 't-info-list-item'
    }
</script>

<style lang="scss" scoped>
    .infolistitem {
        overflow: hidden;

        background-color: #f9f8f4;

        border-radius: 5px;

        padding: 15px;
        margin-bottom: 10px;

        &.link {
            cursor: pointer;

            &:hover {
                background-color: #ecebe7;
            }
        }

        .infolistitem-title {
            display: block;
            font-weight: bold;
        }

        .infolistitem-subtitle {
            display: block;
        }

        .level-left {
            flex-shrink: 1;
            overflow: hidden;

            > .level-item {
                flex-shrink: 1;
                flex-direction: column;
                align-items: flex-start;

                span {
                    white-space: nowrap;
                    overflow: hidden;

                    text-overflow: ellipsis;
                }
            }

            > .icon {
                background-color: white;
                border-radius: 50%;

                margin-right: 20px;
            }
        }

        .level-right {
            margin-left: 10px;
        }
    }

</style>